import { hasRole, Role, IOrganisationResponse } from '@one-tree/library'
import React, { ComponentType, ReactElement } from 'react'
import { Route, Redirect, useRouteMatch } from 'react-router-dom'
import { useAuth } from '../../context/AuthProvider'
import { useOrganisation } from '../../context/OrganisationProvider'
import { RoutePath } from '../../types/Routes'

export interface IOrganisationRouteProps {
  component: ComponentType
  path: string
  requiredRole?: Role
  requiredVar?: keyof IOrganisationResponse
  exact?: boolean
}
function OrganisationRoute(
  props: IOrganisationRouteProps,
): ReactElement | null {
  const { component, path, requiredRole, requiredVar, exact } = props
  const { token } = useAuth()
  const { organisation, organisationUser } = useOrganisation()
  const match = useRouteMatch({ path, exact })

  const isAllowed = requiredRole
    ? organisationUser && hasRole(organisationUser.role, requiredRole)
    : true

  const hasFeature = requiredVar ? organisation?.[requiredVar] : true
  if (!hasFeature) {
    // If user is specifically trying to access this feature, redirect them
    if (match) return <Redirect to={RoutePath.Home} />
    // Otherwise, render nothing (no redirect so we can use this outside a Switch)
    return null
  }

  return token && organisation && isAllowed ? (
    <Route path={path} component={component} exact={exact} />
  ) : (
    <Redirect
      to={{ pathname: RoutePath.Login, state: { referer: document.referrer } }}
    />
  )
}

export default OrganisationRoute
